import { AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import { badgeRenditionEnum, badgePositionEnum } from '../badge.component';
var BadgeDynamicClassesDirective = /** @class */ (function () {
    function BadgeDynamicClassesDirective(_elRef, _renderer) {
        this._elRef = _elRef;
        this._renderer = _renderer;
    }
    BadgeDynamicClassesDirective.prototype.ngAfterViewInit = function () {
        this._processClasses();
    };
    BadgeDynamicClassesDirective.prototype._processClasses = function () {
        var _a = this.appBadgeDynamicClasses, rendition = _a.rendition, position = _a.position;
        if (rendition && rendition in badgeRenditionEnum) {
            this._renderer.addClass(this._elRef.nativeElement, "badge--" + rendition);
        }
        if (position && position in badgePositionEnum) {
            this._renderer.addClass(this._elRef.nativeElement, "badge--position");
            this._renderer.addClass(this._elRef.nativeElement, "badge--position__" + position);
        }
    };
    return BadgeDynamicClassesDirective;
}());
export { BadgeDynamicClassesDirective };
